export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";